module.exports = __webpack_public_path__ + "img/horizontal_4_1_8017.853dcdb8.png";